var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11245_19683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 5.61769C10.6641 4.67555 11.4278 3.9118 12.3699 3.9118H25.1641C26.1062 3.9118 26.8699 4.67555 26.8699 5.61769V12.4412C26.8699 13.3833 26.1062 14.1471 25.1641 14.1471H22.0082H18.4712H15.5258H12.3699C11.4278 14.1471 10.6641 13.3833 10.6641 12.4412V5.61769Z",
    stroke: "#6921C4",
    strokeWidth: 2.34559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.138 18.0198V24.6656C15.138 24.9861 15.0107 25.2934 14.7841 25.52C14.5575 25.7466 14.2502 25.8739 13.9297 25.8739H4.26302C3.94255 25.8739 3.63521 25.7466 3.4086 25.52C3.18199 25.2934 3.05469 24.9861 3.05469 24.6656V7.74892C3.05469 7.42845 3.18199 7.12111 3.4086 6.8945C3.63521 6.66789 3.94255 6.54059 4.26302 6.54059H6.67969",
    stroke: "#FF6019",
    strokeWidth: 2.34559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 8.17651H26.8699",
    stroke: "#6921C4",
    strokeWidth: 2.13235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86719 21.9815H12.3116",
    stroke: "#6921C4",
    strokeWidth: 2.13235,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11245_19683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPresent);
export default __webpack_public_path__ + "static/media/CardPresent.d9ecd4bb.svg";
export { ForwardRef as ReactComponent };